import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { SettingsProvider } from './context/SettingsContext';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';

const Dashboard = lazy(() => import('./pages/Dashboard'));
const Globe = lazy(() => import('./pages/Globe'));
const History = lazy(() => import('./pages/History'));
const Alerts = lazy(() => import('./pages/Alerts'));
const Settings = lazy(() => import('./pages/Settings'));

const PageFallback = () => (
  <div className="flex min-h-screen items-center justify-center">
    <div className="text-zinc-400 text-xs font-mono uppercase tracking-wider dark:text-zinc-500">Loading...</div>
  </div>
);

function App() {
  return (
    <ThemeProvider>
      <SettingsProvider>
        <Router>
          <div className="min-h-screen bg-white text-zinc-900 transition-colors dark:bg-black dark:text-zinc-200">
            <Navbar />
            <Suspense fallback={<PageFallback />}>
              <Routes>
                <Route path="/" element={<Globe />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/globe" element={<Navigate to="/" replace />} />
                <Route path="/history" element={<History />} />
                <Route path="/alerts" element={<Alerts />} />
                <Route path="/settings" element={<Settings />} />
              </Routes>
            </Suspense>
          </div>
        </Router>
      </SettingsProvider>
    </ThemeProvider>
  );
}

export default App;
